import React, { useEffect, useState } from "react";
import { Button, Modal } from "antd";

import authorization from "../../../auth/authorization";
import AddUser from "./AddUser";
import EditUser from "./EditUser";
import {
  USER_FORM_MODAL_CLASS,
  UserFormModalGlobalStyles,
} from "./Styles";

export const ADD_USER_FORM_ID = "add-user-form";
export const EDIT_USER_FORM_ID = "edit-user-form";

const UserFormModal = ({
  open,
  editId = "",
  selectedUser,
  userRoles,
  clients,
  userRoleType,
  onClose,
  onUserChange,
  canDeactivateUser,
}) => {
  const [formSubmitting, setFormSubmitting] = useState(false);
  const isEditMode = editId !== "";
  const activeFormId = isEditMode ? EDIT_USER_FORM_ID : ADD_USER_FORM_ID;

  useEffect(() => {
    if (!open) {
      setFormSubmitting(false);
    }
  }, [open]);

  const closeModal = () => {
    setFormSubmitting(false);
    onClose();
  };

  const handleUserAdded = () => {
    onUserChange();
    closeModal();
  };

  const formModalFooter = isEditMode
    ? [
        <Button key="cancel" onClick={closeModal}>
          Cancel
        </Button>,
        <Button
          key="save"
          type="primary"
          htmlType="submit"
          form={activeFormId}
          loading={formSubmitting}
        >
          Save
        </Button>,
      ]
    : [
        <Button
          key="add"
          type="primary"
          htmlType="submit"
          form={activeFormId}
          loading={formSubmitting}
        >
          Add
        </Button>,
      ];

  return (
    <>
      <UserFormModalGlobalStyles />
      <Modal
        title={isEditMode ? "Edit Admin" : "Add Admin"}
        open={open}
        className={USER_FORM_MODAL_CLASS}
        footer={formModalFooter}
        width="min(1200px, calc(100vw - 48px))"
        style={{ top: 24 }}
        bodyStyle={{
          maxHeight: "calc(100vh - 120px)",
          overflowY: "auto",
          overflowX: "hidden",
          padding: "16px 16px 96px",
        }}
        destroyOnClose
        onCancel={closeModal}
      >
        {isEditMode && authorization.isAllowed(userRoleType, "adminUserUpdate") && (
          <EditUser
            userId={editId}
            selectedUser={selectedUser}
            afterEdit={closeModal}
            userRoles={userRoles}
            clients={clients}
            updateUser={onUserChange}
            userRoleType={userRoleType}
            canDeactivateUser={canDeactivateUser}
            formId={EDIT_USER_FORM_ID}
            hideActions
            onLoadingChange={setFormSubmitting}
          />
        )}
        {!isEditMode && authorization.isAllowed(userRoleType, "registerAdminUser") && (
          <AddUser
            adduser={handleUserAdded}
            clients={clients}
            userRoles={userRoles}
            userRoleType={userRoleType}
            formId={ADD_USER_FORM_ID}
            hideActions
            onLoadingChange={setFormSubmitting}
          />
        )}
      </Modal>
    </>
  );
};

export default UserFormModal;
